import {
  pendingReviewSchema,
  reputationBatchSchema,
  reputationSchema,
  reviewSchema,
  type CreateReviewInput,
  type Page,
  type PendingReview,
  type Reputation,
  type Review,
  type ReviewListQuery,
} from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';
import { fetchPage } from '@/lib/api-page';
import { z } from 'zod';

export async function createReview(input: CreateReviewInput): Promise<Review> {
  return reviewSchema.parse(await post<unknown>('/reviews', input));
}

/** Reviews about a person. Omit `personId` for your own. */
export function fetchReviews(query: Partial<ReviewListQuery> = {}): Promise<Page<Review>> {
  return fetchPage('/reviews', reviewSchema, query);
}

export async function fetchPendingReviews(): Promise<PendingReview[]> {
  const result = await apiFetch<unknown>('/reviews/pending');
  return z.object({ items: z.array(pendingReviewSchema) }).parse(result).items;
}

export async function fetchReputation(personId: string): Promise<Reputation> {
  return reputationSchema.parse(await apiFetch<unknown>(`/reviews/reputation/${personId}`));
}

/** One request for a whole list of people. */
export async function fetchReputations(
  personIds: string[],
): Promise<Record<string, Reputation>> {
  if (personIds.length === 0) return {};
  const result = await post<unknown>('/reviews/reputations', { personIds });
  return reputationBatchSchema.parse(result).reputations;
}
